import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import homePageReducer from './container/HomePage/slice';
import casePageReducer from './container/CasePage/slice';
import settingPageReducer from './container/SettingPage/slice';
import sharedPageReducer from './container/SharedPage/slice';

export const history = createBrowserHistory();

export default configureStore({
  reducer: {
    homePageReducer,
    casePageReducer,
    settingPageReducer,
    sharedPageReducer,
  },
  devTools: process.env.REACT_APP_ENV === 'dev',
});
